import {PolyDictionary} from './../../../../../@polygonjs/polygonjs/dist/src/types/GlobalTypes.d';
interface EditorPanelFileSelectorOptions {
	param: StringParam;
}
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from 'vue';
import {StringParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/String';
export class EditorPanelFileSelectorStoreControllerClass {
	private static _instance: EditorPanelFileSelectorStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelFileSelectorStoreControllerClass());
	}

	private constructor() {}

	private _paramId: Ref<CoreGraphNodeId | null> = ref(null);
	public readonly folderPathByParamId: Ref<PolyDictionary<string[]>> = ref({});
	// private _filter: Ref<string> = ref('');

	// getters
	paramId(): CoreGraphNodeId | null {
		// console.log(this._paramId.value);
		// return 451;
		return this._paramId.value;
	}
	// folderPathByParamId() {
	// 	return this._folderPathByParamId;
	// }
	// filter(): string {
	// 	return this._filter.value;
	// }

	// mutations
	open(options: EditorPanelFileSelectorOptions): void {
		this._paramId.value = options.param.graphNodeId();
	}
	close() {
		this._paramId.value = null;
	}
	// setFilter(filter: string) {
	// 	this._filter.value = filter;
	// }
}

export const EditorPanelFileSelectorStoreController = EditorPanelFileSelectorStoreControllerClass.instance();
